import * as Yup from "yup";
import { createPersologClassFormSchema } from "../persolog-class-form/persolog-class-form.consts";
import { PersologClassFormState } from "../persolog-class-form/persolog-class-form.types";

type TFunc = (key: string, options?: Record<string, unknown>) => string;

export const NUMBER_OF_PERSOLOG_QUESTIONS_REQUIRED = 10;

export const createPersologElementFormSchema = (t: TFunc) =>
	Yup.object().shape({
		title: Yup.string().required(t("validation:titleFieldRequired")),
		classes: Yup.array()
			.of(createPersologClassFormSchema(t))
			.required(t("validation:classesRequired")),
	});

export const persologClasses: readonly PersologClassFormState[] = [
	{
		title: "Dominant",
		text: "",
		image: undefined,
		classType: "D",
	},
	{
		title: "Initiative",
		text: "",
		image: undefined,
		classType: "I",
	},
	{
		title: "Stetigkeit",
		text: "",
		image: undefined,
		classType: "S",
	},
	{
		title: "Gewissenhaft",
		text: "",
		image: undefined,
		classType: "G",
	},
] as const;
